<template>
  <div>
    <h2>{{ title }}</h2>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <input-search />
        <circle-button @click.native="createMembership" />
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center" v-for="header in headers" :key="header.id">
                {{ header.text }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataTable" :key="item.id">
              <td align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
              <td>{{ item.branch ? item.branch.branch_name_th : "" }}</td>
              <td>{{ item.title_th }}</td>
              <td>{{ item.updated_at | moment("DD-MM-YYYY") }}</td>
              <td>{{ item.orders }}</td>
              <td>
                <a @click="showMembership(item.id)">
                  <icon-pencil />
                </a>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
import InputTextField from "../../../components/Input/InputTextField";
import CircleButton from "../../../components/Button/CircleButton";
import IconPencil from "../../../components/Icon/icon-pencil";
import InputSearch from "../../../components/Input/InputSearch";
import Paginate from "../../../components/Layout/Paginate";
export default {
  name: "MembershipTable",
  components: {Paginate, InputSearch, IconPencil, CircleButton, InputTextField },
  data() {
    return {
      title: "Membership",
      headers: [
        { id: 2, text: "No." },
        { id: 3, text: "Branch" },
        { id: 4, text: "Membership" },
        { id: 5, text: "Update date" },
        { id: 6, text: "Order" },
        { id: 7, text: "edit" }
      ],
      dataTable: [],
      dataPaginate: {
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 1,
        total: 1,
        to: 1
      }
    };
  },
  created() {
    this.getMembershipTable(1);
  },
  methods: {
    goToMembershipEdit() {
      this.$router.push("/membership/edit");
    },
    getMembershipTable(page) {
      this.$store.dispatch("Membership/getMembership", page).then(res => {
        if (res.response_code === 200) {
          this.dataTable = res.result.data;
          this.dataPaginate = {
            current_page: res.result.current_page,
            from: res.result.from,
            last_page: res.result.last_page,
            per_page: res.result.per_page,
            total: res.result.total,
            to: res.result.to
          }
        } else {
          alert(res.response_msg);
        }
      });
    },
    changePage(val){
      this.dataPaginate.current_page = val;
      this.$store.dispatch("Membership/getMembership", this.dataPaginate.current_page).then(res => {
        if (res.response_code == 200) {
          this.dataTable = res.result.data;
          this.dataPaginate = {
            current_page: res.result.current_page,
            from: res.result.from,
            last_page: res.result.last_page,
            per_page: res.result.per_page,
            total: res.result.total,
            to: res.result.to
          }
        } else {
          alert(res.response_msg);
        }
      });
    },
    createMembership() {
      this.$store.dispatch("Membership/clearFormData").then(() => {
        this.goToMembershipEdit();
      });
    },
    showMembership(id) {
      this.$store.dispatch("Membership/showMembership", id).then(res => {
        if (res.response_code == 200) {
          this.$store.dispatch("Membership/setFormMembership", res.result).then(() => {
            this.goToMembershipEdit();
          });
        } else {
          alert(res.response_msg);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
  .branch-data {
    background-color: transparent;
    margin: 20px;
  }
</style>
